import { render, staticRenderFns } from "./CustomFieldValues.vue?vue&type=template&id=0310a1ee"
import script from "./CustomFieldValues.vue?vue&type=script&lang=js"
export * from "./CustomFieldValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports